module.exports = __webpack_public_path__ + "img/microsoft-teams.cfd0b307.svg";